/* eslint-disable import/prefer-default-export */
import { fetch } from 'server/api'
import { forEach } from 'lodash'

export const getBrandByUid = (brandUid, params = {}) => {
  let paramsUrl = ''

  const headersToForward = { 'X-Record-Visit': false }

  forEach(params, (value, key) => {
    paramsUrl += `&${key}=${value}`
  })

  return fetch(
    `brands/uid/${brandUid}?${encodeURI(paramsUrl)}`,
    headersToForward,
  )
}
